<template>
  <div>
    <Head />

    <div class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">修改聯絡資訊</li>
      </ol>
    </div>

    <div class="wrapper sign_up register change_password">
      <section class="main">
        <div class="container">
          <h1>修改聯絡資訊</h1>
          <div class="box">
            <div class="form-group">
              <label for="">姓名</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入姓名" v-model="Nickname">
            </div>
            <div class="form-group">
              <label for="">職稱</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入職稱" v-model="JobTitle">
            </div>
            <div class="form-group">
              <label for="">電話</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入電話" v-model="Phone">
            </div>
            <div class="btn_box">
              <button @click="changeInfo()">送　　出</button>
            </div>
          </div>
          <hr>
        </div>
      </section>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "ResetInfo",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      MemberData: null,
      Nickname: "",
      JobTitle: "",
      Phone: "",
    };
  },
  beforeCreate: function () {
    if (!$cookies.isKey("is_login_token")) {
      this.$router.push({
        name: "Home",
      });
    }
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Member",
        {
          params: {
            token: $cookies.get("is_login_token")
          },
        }
      )
      .then((response) => {
        this.MemberData = response.data;
        this.Nickname = this.MemberData.User.Nickname;
        this.JobTitle = this.MemberData.User.JobTitle;
        this.Phone = this.MemberData.User.Phone;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
  },
  updated: function () {
  },
  methods: {
    async getRecaptchaToken() {
      try {
        await this.$recaptchaLoaded();
        return await this.$recaptcha('login');
      } catch {
        Swal.fire({
          title: "錯誤",
          text: "請確認網路環境後再試一次（RG）",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return null;
      }
    },
    async changeInfo() {
      if ((this.Nickname == "")) {
        Swal.fire({
          title: "錯誤",
          text: "請輸入姓名",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if ((this.JobTitle == "")) {
        Swal.fire({
          title: "錯誤",
          text: "請輸入職稱",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if ((this.Phone == "")) {
        Swal.fire({
          title: "錯誤",
          text: "請輸入電話",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (!Validate.reg_number(this.Phone)) {
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "電話格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      // 我不是機器人
      let recaptchaToken = await this.getRecaptchaToken();
      if (!recaptchaToken) {
        return;
      }
      // 顯示請稍候
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 組合並送出
      let token = AES.encrypt(this.MemberData.User.Account + "|" + this.Nickname + "|" + this.JobTitle+ "|" + this.Phone + "|" + recaptchaToken);
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/ResetInfo",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            Swal.fire({
              title: "聯絡資訊修改完成",
              icon: "success",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              timer: 1500,
              willClose: () => {
                location.reload();
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        },
      });
    },
  },
};
</script>
